export default __webpack_public_path__ + "static/media/logo.8395e8f4.jpg";